import React from 'react';
import styles from './styles.scss';
import Utils from '../../../../utils/comments-utils'
import CommentDropdown from '../../../atoms/comments/comment-dropdown';

interface SortByDropdownProps {
    sortType: string,
    selectHandler: (value: string) => void,
}

const SortByDropdown = function CommentBanner({ selectHandler, sortType }: SortByDropdownProps) {
    const options = new Map<string, string>(
        [
            [Utils.SortOrders.Newest.Key, Utils.SortOrders.Newest.Value],
            [Utils.SortOrders.Oldest.Key, Utils.SortOrders.Oldest.Value],
            [Utils.SortOrders.HighestAmount.Key, Utils.SortOrders.HighestAmount.Value],
            [Utils.SortOrders.LowestAmount.Key, Utils.SortOrders.LowestAmount.Value],
        ]
    );

    return (
        <div className={`${styles['select--align-end']} column`}>
            <div className={styles['select--display']}>
                <label className={styles['select__label-text']}>Sort by</label>
                <div className={styles['select--background']}>
                    <CommentDropdown
                        selectedValue={sortType}
                        selectHandler={selectHandler}
                        testid="Sortby-dropdown"
                        options={options} />
                </div>
            </div>
        </div>
    );
};

export default SortByDropdown;